import { type LevelProgressCoachComment } from '@/lib/types';
import { useCallback, useContext, useState } from 'react';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import TextEditor from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/utils/TextEditor';
import useApi from '@/lib/api/useApi';
import Space from '@/components/Space';
import useRubricsPortfolioApiEndpoint from '../../../../useRubricsPortfolioApiEndpoint';

type LevelProgressCoachCommentEditorProps = {
  levelProgressCoachComment: LevelProgressCoachComment;
  onClose: () => void;
};

const LevelProgressCoachCommentEditor = ({
  levelProgressCoachComment,
  onClose,
}: LevelProgressCoachCommentEditorProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);
  const [saving, setSaving] = useState(false);

  const handleSave = useCallback(
    async (value: string): Promise<void> => {
      setSaving(true);

      const updatedLevelProgressCoachComment =
        await api.put<LevelProgressCoachComment>(
          `${rubricsPortfolioApiEndpoint}/level-progress-coach-comments/${levelProgressCoachComment.id}`,
          {
            content: value,
          },
        );

      setPortfolio(portfolio => {
        portfolio.levelProgressCoachComments![
          levelProgressCoachComment.levelId
        ][levelProgressCoachComment.id] = {
          ...portfolio.levelProgressCoachComments![
            levelProgressCoachComment.levelId
          ][levelProgressCoachComment.id],
          ...updatedLevelProgressCoachComment,
        };
      });

      setSaving(false);
      onClose();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [levelProgressCoachComment.id, levelProgressCoachComment.levelId],
  );

  return (
    <>
      <Space height={18} />
      <TextEditor
        initialValue={levelProgressCoachComment.content}
        onCancel={onClose}
        onSave={handleSave}
        disabled={saving}
        disableSaveWhenEmpty
      />
    </>
  );
};

export default LevelProgressCoachCommentEditor;
